/**
 * @generated SignedSource<<1cdc831b5a6114c31ec11d4e623ab1af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileActions_Freelancer$data = {
  readonly canMakeOffer: boolean | null | undefined;
  readonly canNotify: boolean | null | undefined;
  readonly directChatThread: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly isChatContact: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChatButton_Recipient" | "MasqButton_User" | "NotifyAboutJob_User">;
  readonly " $fragmentType": "ProfileActions_Freelancer";
};
export type ProfileActions_Freelancer$key = {
  readonly " $data"?: ProfileActions_Freelancer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileActions_Freelancer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileActions_Freelancer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canNotify",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canMakeOffer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isChatContact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatThread",
      "kind": "LinkedField",
      "name": "directChatThread",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotifyAboutJob_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MasqButton_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatButton_Recipient"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "687bbaa8ecd5cc874366fbe7bdaed6b2";

export default node;
